export const REFERRAL_AMOUNT = 25;
